"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const constants_1 = require("core/constants");
const useWindowSize_1 = require("hooks/useWindowSize");
const React = __importStar(require("react"));
const PlanFrequencySelector = ({ groupItems, setFrequency }) => {
    if (!groupItems) {
        return null;
    }
    const [openTooltip, setOpenTooltip] = React.useState(false);
    const [tooltipOffset, setTooltipOffset] = React.useState(0); // Default value
    const [tooltipSide, setTooltipSide] = React.useState('left');
    const [tooltipShownOnce, setTooltipShownOnce] = React.useState(false);
    const annualRadioRef = React.useRef(null);
    const [windowWidth] = (0, useWindowSize_1.useWindowSize)();
    // Close tooltip after timeout when opened
    React.useEffect(() => {
        let timeoutId;
        if (openTooltip) {
            timeoutId = setTimeout(() => {
                setOpenTooltip(false);
            }, constants_1.TOOLTIP_TIMEOUT_MS);
        }
        return () => {
            if (timeoutId)
                clearTimeout(timeoutId);
        };
    }, [openTooltip]);
    // Calculate tooltip offset based on the annual radio button's position
    const calculateTooltipOffset = React.useCallback(() => {
        if (annualRadioRef.current) {
            // Get the width of the annual radio button
            const radioWidth = annualRadioRef.current.offsetWidth;
            if (windowWidth < 768) {
                setTooltipSide('bottom');
                setTooltipOffset(0);
            }
            else {
                setTooltipSide('left');
                // Desktop view - use the original offset
                setTooltipOffset(radioWidth + 130);
            }
        }
    }, [windowWidth]);
    // Calculate offset on mount
    React.useEffect(() => {
        calculateTooltipOffset();
    }, [calculateTooltipOffset]);
    return (React.createElement(snap_ui_1.TooltipProvider, null,
        React.createElement("div", { className: "plan-frequency-selector d:sui-w-1/3 sui-flex sui-justify-center sui-items-center sui-gap-1 d:sui-gap-2", "data-testid": "plan-frequency-selector" },
            React.createElement(snap_ui_1.Tooltip, { open: openTooltip },
                React.createElement(snap_ui_1.TooltipContent, { align: "center", side: tooltipSide, className: "sui-shadow-0", sideOffset: tooltipOffset },
                    React.createElement("h3", { className: "sui-font-semibold sui-mb-1" }, "Save up to $114 with Annual"),
                    React.createElement("p", null, "When you choose an annual subscription you get TeamSnap all year \u2014 and save big."),
                    React.createElement(snap_ui_1.TooltipAction, { onClick: () => setOpenTooltip(false) }, "Close")),
                React.createElement("div", { ref: annualRadioRef },
                    React.createElement(snap_ui_1.Radio, { "data-testid": "annually-radio-button", className: "radio-button", name: "frequency", id: "yearly", label: "Annually", value: "year", extraProps: {
                            input: {
                                defaultChecked: true,
                            },
                        }, onChange: (e) => {
                            setFrequency(e.target.value);
                            setOpenTooltip(false);
                        } })),
                React.createElement(snap_ui_1.Status, { state: "info", "data-testid": "badge-label-mobile", className: "plan-frequency-selector__badge" }, "SAVE 40%"),
                React.createElement(snap_ui_1.TooltipTrigger, { className: "sui-bg-transparent sui-border-none" },
                    React.createElement(snap_ui_1.Radio, { "data-testid": "monthly-radio-button", className: "radio-button", name: "frequency", id: "monthly", label: "Monthly", value: "month", onChange: (e) => {
                            setFrequency(e.target.value);
                            if (!tooltipShownOnce) {
                                setOpenTooltip(true);
                                setTooltipShownOnce(true);
                            }
                        } }))))));
};
exports.default = PlanFrequencySelector;
